<template>
  <aside
    class="menu"
    :class="{ 'menu--collapsed': sidebarCollapsed }">
    <div class="menu__title">
      <a href="/">
        <img
          src="@/assets/images/logo.svg"
          alt="logo"
          class="menu__logo">
      </a>
      <i class="icon-collapse menu__trigger" @click="toggleSidebar" />
    </div>
    <ul class="menu-list">
      <template v-for="item in items">
        <li
          v-if="showItem(item.visible)"
          :id="item.wrapperId"
          :key="item.name"
          :class="{ 'menu-list__item--bottom': item.bottom }">
          <router-link
            v-if="item.to"
            :to="item.to"
            :active-class="isItemActive(item.isActive) ? null : 'is-active'"
            :class="{ 'is-active': isItemActive(item.isActive) }"
            class="menu-list__link">
            <i :class="item.icon" />
            <span class="menu-list__title">{{ item.name }}</span>
          </router-link>
          <a
            v-else
            href="#"
            class="menu-list__link"
            @click.prevent="item.action">
            <i :class="item.icon" />
            <span class="menu-list__title">{{ item.name}}</span>
          </a>
        </li>
      </template>
    </ul>
  </aside>
</template>

<script>
import Sidebar from './Sidebar';

export default Sidebar;
</script>

<style lang="scss" scoped>
@import './Sidebar';
</style>
